const config = {
  cookie: {
    path: '/'
  }
};
let SUFFIX = "_____timeout";

const _set = function (cname, cvalue, expries, path) {
    let ck = cname + "=" + cvalue;
    if (expries != undefined) {
        let d = new Date();
        d.setTime(d.getTime() + expries);
        let expires = "expires=" + d.toUTCString();
        ck = ck + ";" + expires;
    }
    path = path ? path : config.cookie.path;
    if (path) {
        ck = ck + ";path=" + path;
    }
    document.cookie = ck;
}

const set = function (cname, cvalue, expries, path) {
    _set(cname, cvalue, undefined, path);
    if (expries && expries >= 0) {
        if (expries == 0) {
            _clear(cname, path);
        } else {
            _set(cname + SUFFIX, '' + (Date.now() + expries), undefined, path);
        }
    }
}

const _get = function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.startsWith(" "))
            c = c.substring(1);
        if (c.indexOf(name) != -1) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const get = function (cname) {
    let value = _get(cname);
    if (!value) {
        return value;
    }
    let exp = _get(cname + SUFFIX);
    if (exp) {
        if (Date.now() < +exp) {
            return value;
        }
        else {
            _clear(cname, '');
            return null;
        }
    }
    else {
        return value;
    }
}

const clear = function (cname, path) {
    _set(cname + SUFFIX, "", -1, path);
    _set(cname, "", -1, path);
}

const _clear = function (cname, path) {
    _set(cname, "", -1, path);
}

export default {
    _set,
    set,
    _get,
    get,
    clear,
    _clear
};
